import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

import { resolveFandomCardFields } from '@/features/fanfic-card/utils/resolveFandomCardFields.util';
import { mapCharactersToCardFields } from '@/features/fanfic-card/utils/resolveCharacterCardFields.util';
import { resolveFanficPublishedAt } from '@/features/fanfic-card/utils/resolve-fanfic-published-at.util';
import { getRandomPlaceholder } from '@/lib/fanfic-placeholders';

/**
 * Format date string to DD.MM.YY format
 */
const formatDate = (dateString?: string): string => {
  if (!dateString) return 'Неизвестно';
  const date = new Date(dateString);
  return format(date, 'dd.MM.yy', { locale: ru });
};

/**
 * Transform raw fanfic data from API to display format
 * Memoized to prevent unnecessary recalculations
 */
export const transformFanficData = (fanfic: any) => {
  const fandomFields = resolveFandomCardFields(fanfic.fandom, fanfic.universe);

  return {
    id: fanfic.id,
    title: fanfic.title || 'Без названия',
    description: fanfic.description || 'Без описания',
    author: fanfic.author?.name || fanfic.userId || 'Неизвестный автор',
    rating: fanfic.rating || 'G',
    chaptersCount:
      typeof fanfic.chaptersCount === 'number'
        ? fanfic.chaptersCount
        : (fanfic.chapters?.length ?? 0),
    score: fanfic.score || 0,
    direction: fanfic.direction || '♂ Гет',
    likes: fanfic.likesCount || 0,
    views: fanfic.readersCount || 0,
    date: (() => {
      const publishedAt = resolveFanficPublishedAt(fanfic);
      return publishedAt ? formatDate(publishedAt) : undefined;
    })(),
    status: fanfic['post-status'] || fanfic.status || 'В процессе',
    cover: fanfic?.heroImage?.url
      ? fanfic?.heroImage?.url.includes('http')
        ? fanfic?.heroImage?.url
        : fanfic?.heroImage?.url
      : getRandomPlaceholder(fanfic.id),
    createdAt: fanfic.createdAt,
    publishedAt: fanfic.publishedAt,
    updatedAt: fanfic.updatedAt,
    userLiked: fanfic.userLiked || false,
    type: fanfic.type || 'fanfic',
    tags: fanfic.tags || [],
    characters: mapCharactersToCardFields(fanfic.characters),
    pairings: fanfic.pairings || [],
    size: fanfic.size,
    totalWordCount: fanfic.totalWordCount,
    readingProgress: fanfic.readingProgress,
    focus: fanfic.focus,
    note: fanfic.note || '',
    fandom: fandomFields.title,
    fandomId: fandomFields.id,
    fandomPermanentUrl: fandomFields.permanentUrl,
  };
};
